const testimonials = [
  {
    name: "Sarah M.",
    location: "Delray Beach, FL",
    rating: 5,
    text: "I had a family emergency overseas and needed my passport renewed in under a week. Fast Passport Center walked me through every step, reviewed my documents, and I had my new passport in 4 days. I couldn't believe how smooth it was.",
    service: "Passport Renewal",
  },
  {
    name: "James K.",
    location: "Boynton Beach, FL",
    rating: 5,
    text: "Our cruise was in 10 days and my son's passport had expired. They told us exactly which clerk to visit, what forms to bring, and handled the expedited submission. We got his passport back with time to spare. Highly recommend.",
    service: "Child Passport",
  },
  {
    name: "Rachel T.",
    location: "Boca Raton, FL",
    rating: 5,
    text: "Business trip to Europe got moved up by two weeks. I panicked, called FPC, and started my order the same day. Shipped from Delray overnight and had my passport in under a week. Their team answered every question I had.",
    service: "Expedited Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function DelrayTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What South Florida Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Delray Beach, Boca Raton, and Boynton Beach who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}